module.exports = __webpack_public_path__ + "static/team_img2-42dd62faf6debf815cd3a0057190e8a4.png";